import {
  type MergeEntitySuggestionRequest,
  type MergeEntitySuggestionResponse
} from '@bliks-io/contracts';
import {
  invalidateSuggestionResolutionSurfaces,
  useEntitySuggestionAction
} from './useEntitySuggestionAction';

export function useMergeEntitySuggestion(suggestionId: string) {
  return useEntitySuggestionAction<MergeEntitySuggestionRequest, MergeEntitySuggestionResponse>({
    suggestionId,
    verb: 'merge',
    // The merge promotes/creates live assignments, rewrites refs everywhere
    // and extends the merged-into entity.
    extraInvalidations: (qc) => invalidateSuggestionResolutionSurfaces(qc, { entityLists: true })
  });
}
